import { createAction } from 'redux-act';

export type NotificationPayload =
  | string
  | {
      text: string;
      options?: Record<string, unknown>;
    };

export const showErrorMessage = createAction<NotificationPayload>();
export const showSuccessMessage = createAction<NotificationPayload>();
export const showInfoMessage = createAction<NotificationPayload>();
